export const buttonsLabels = {
  selectButtonLabel: '18112016-094717-6247',
  closeButtonLabel: '23082016-151750-9997',
  checkoutButtonLabel: '11042017-054442-3121',
  continueButtonLabel: '22112016-144517-2631',
  bookNowButtonLabel: '16092015-130050-9529',
  createAccountButtonLabel: '20092016-124756-4559',
  checkoutAsGuestButtonLabel: '19122018-152801-0033',
  submitButtonLabel: '24112016-132214-2565'
};

export const bookingLabels = {
  pricesExcludeTaxWarning: '21112016-163359-5517',
  pricesExcludeTaxLabel: '19122018-152801-0017',
  total: '21112016-163156-4172',
  meetingRoom: '10082015-153347-3636',
  trainingRoom: '21092015-124837-1967',
  dayOffice: '10082015-153140-4790',
  dayCoworking: '09102020-091228-5811',
  summaryTitle: '19122018-152801-0014',
  summaryTitleMeetingRoom: '16052022-125346-7034',
  summaryTitleTrainingRoom: '16052022-130735-6029',
};

export const formLabels = {
  emailLabel: '12022016-112618-3356',
  emailAddressLabel: '19122018-152801-0026',
  checkEmailRequired: '19122018-152801-0036',
  pleaseSelectLabel: '28122016-131054-1228'
};

export const roomLabels = {
  unavailableLabel: '18112016-145211-5140',
  adjustDate: '19122018-152801-0011',
  aboutThisCentreLinkLabel: '19122018-152801-0012',
  meetingRoomsPlural: '11012016-151053-1321',
  trainingRoomsPlural: '11062018-103819-0020'
};

export const commonPhrases = {
  dearCustomer: '22032019-144946-3895',
};

export const commonLabels = {
  termsAndConditionsLabel: 'terms and conditions',
};
